module.exports = __webpack_public_path__ + "img/ndz.4e01e371.svg";